import { GaEventService } from '@analytics/services/ga.event.service';
import { Location } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  OnChanges,
} from '@angular/core';
import { isLiveChatActive } from '@dgx-pr-spa/shared/util';
import { LiveChatService } from '@pages/services/live-chat.service';

@Component({
  selector: 'app-delivery-unavailable-modal',
  templateUrl: './delivery-unavailable-modal.component.html',
  styleUrls: ['./delivery-unavailable-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DeliveryUnavailableModalComponent implements OnChanges {
  constructor(
    private elementRef: ElementRef,
    private readonly location: Location,
    private readonly gaEventService: GaEventService,
    public liveChatService: LiveChatService
  ) {}

  @Input() numberOfReplacementOffers: number;

  @Input() isDeliveryDatesApiError: boolean;

  isLiveChatActive = isLiveChatActive();

  ngOnChanges() {
    if (this.isDeliveryDatesApiError) {
      this.gaEventService.DeliveryApiErrorModal();
    } else {
      this.gaEventService.DeliveryUnavailableModal();
    }
  }

  /**
   * Navigate to route on click
   */
  onBackLinkClick() {
    this.location.back();
  }

  openLiveChat(): void {
    // Remove current dialog window!
    this.elementRef.nativeElement.remove();
    this.liveChatService.openLiveChat();
  }
}
